import en from './en/namespaces';

const translations = { en };

export default translations;
